"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getColorLuma;
var _lodash = _interopRequireDefault(require("lodash"));
var _hexToRgb = _interopRequireDefault(require("./hexToRgb"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function getColorLuma(color) {
  var c = {};
  if (_lodash["default"].isString(color)) {
    c = (0, _hexToRgb["default"])(color);
  } else if (_lodash["default"].isObject(color)) {
    c = color;
  }
  // per ITU-R BT.709
  return 0.2126 * c.r + 0.7152 * c.g + 0.0722 * c.b; // eslint-disable-line no-mixed-operators
}